var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconColorWheel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6427_27085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 14.0013C0.666992 6.63741 6.63643 0.667969 14.0003 0.667969C21.3642 0.667969 27.3337 6.63741 27.3337 14.0013C27.3337 21.3652 21.3642 27.3346 14.0003 27.3346C6.63643 27.3346 0.666992 21.3652 0.666992 14.0013ZM14.0003 21.9745C18.4038 21.9745 21.9736 18.4048 21.9736 14.0013C21.9736 9.59782 18.4038 6.02808 14.0003 6.02808C9.59684 6.02808 6.0271 9.59782 6.0271 14.0013C6.0271 18.4048 9.59684 21.9745 14.0003 21.9745Z",
    fill: "#83D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 27.3357V21.9756C15.0179 21.9756 15.9906 21.7852 16.8855 21.4375L18.7194 26.4762C17.252 27.0316 15.6618 27.3357 14 27.3357Z",
    fill: "#3FEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8857 21.4386C17.807 21.0807 18.6456 20.5564 19.3646 19.9023L22.8121 24.0102C21.6182 25.0618 20.2349 25.9037 18.7196 26.4773L16.8857 21.4386Z",
    fill: "#1DD1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3647 19.8972C20.0762 19.2496 20.6703 18.4753 21.1112 17.6094L25.7572 20.2921C25.0024 21.7 24.0012 22.9571 22.812 24.005L19.3647 19.8972Z",
    fill: "#17B5BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7554 12.1429L27.0404 11.2109C27.2331 12.1118 27.334 13.0461 27.334 14.0043C27.334 14.6267 27.2911 15.2389 27.2085 15.8388L21.9234 14.9074C21.9566 14.6112 21.9739 14.3097 21.9739 14.0043C21.9739 13.363 21.8982 12.7403 21.7554 12.1429Z",
    fill: "#9BE058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6826 9.64754L25.329 6.96484C26.128 8.24943 26.7149 9.67928 27.04 11.2062L21.755 12.1382C21.54 11.2389 21.1729 10.3993 20.6826 9.64754Z",
    fill: "#C0FF66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8804 7.69442L22.3278 3.58594C23.5103 4.53239 24.5282 5.67598 25.3314 6.96688L20.685 9.64958C20.1961 8.90108 19.5849 8.24007 18.8804 7.69442Z",
    fill: "#FFDF46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59912 1.41219C10.9775 0.92981 12.4584 0.667969 14.001 0.667969V6.02808C13.1021 6.02808 12.2385 6.1768 11.4324 6.45085L9.59912 1.41219Z",
    fill: "#FC3E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67725 3.58752C6.84119 2.65613 8.16463 1.91577 9.59998 1.41406H9.60059L11.4339 6.45272C10.592 6.73877 9.8136 7.16215 9.12472 7.696L5.67725 3.58752Z",
    fill: "#F01054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67188 6.96688C3.4751 5.67598 4.49296 4.53259 5.67542 3.58594L9.12288 7.69442C8.41834 8.24007 7.80717 8.90108 7.31848 9.64958L2.67188 6.96688Z",
    fill: "#7884EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.791992 15.8337L6.07703 14.9023C6.18608 15.8675 6.46704 16.7808 6.889 17.6103L2.2428 20.293C1.512 18.9307 1.0109 17.4272 0.791992 15.8337Z",
    fill: "#1685FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24512 20.2921L6.89111 17.6094C7.33219 18.4753 7.92627 19.2496 8.63774 19.8972L5.19027 24.005C4.0013 22.9571 3.00012 21.7 2.24512 20.2921Z",
    fill: "#43A3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 24.0102L8.63497 19.9023C9.35376 20.5564 10.1924 21.0807 11.1138 21.4386L9.2797 26.4773C7.76461 25.9037 6.38135 25.0618 5.1875 24.0102Z",
    fill: "#64BDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.958496 11.2062C1.28361 9.67928 1.87056 8.24943 2.66951 6.96484L7.31592 9.64754C6.8256 10.3993 6.45858 11.2389 6.24353 12.1382L0.958496 11.2062Z",
    fill: "#4A5BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1094 17.6103C21.5311 16.7806 21.8121 15.8675 21.9211 14.9023L27.2062 15.8337C26.9873 17.4272 26.4862 18.9307 25.7554 20.293L21.1094 17.6103Z",
    fill: "#1CC939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 14.0043C0.666992 13.0461 0.767904 12.1118 0.960571 11.2109L6.24561 12.1429C6.10278 12.7403 6.0271 13.363 6.0271 14.0043C6.0271 14.3097 6.04439 14.6112 6.07756 14.9074L0.792521 15.8388C0.70992 15.2389 0.666992 14.6267 0.666992 14.0043Z",
    fill: "#364EC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5679 6.45272L18.4018 1.41406C19.8371 1.91577 21.1608 2.65613 22.3245 3.58773L18.8772 7.696C18.1882 7.16215 17.4095 6.73877 16.5679 6.45272Z",
    fill: "#F9B200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.02808V0.667969C15.5426 0.667969 17.0241 0.92981 18.4025 1.41219L16.5684 6.45085C15.7625 6.1768 14.8988 6.02808 14 6.02808Z",
    fill: "#FD6096"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6427_27085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 26.6667,
    fill: "white",
    transform: "translate(0.666992 0.667969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColorWheel);
export default __webpack_public_path__ + "static/media/icon_color_wheel.5151cac4335ee4fcd7bdd7b3d5c6fdb7.svg";
export { ForwardRef as ReactComponent };